<template>
  <div>
    <button
      class="btn btn-light p-2 emoji"
      v-for="(emoji, index) in emojis"
      :key="`emoji-${index}`"
      @click="select(emoji)"
    >
      {{ emoji }}
    </button>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import emojis from '@/resources/json/ocular-emojis.json'

@Component
export default class Emojis extends Vue {
  data () {
    return {
      emojis: emojis
    }
  }

  select (emoji) {
    this.$emit('select', emoji)
  }
}
</script>
